(function () {
  const CUSTOM_SORT_VALUES = ['event_date_asc', 'event_date_desc'];

  function sortByEventDate(direction) {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.grid__item'));

    items.sort((a, b) => {
      const cardA = a.querySelector('[data-event-date]');
      const cardB = b.querySelector('[data-event-date]');
      const dateA = parseInt(cardA?.dataset.eventDate || '0', 10);
      const dateB = parseInt(cardB?.dataset.eventDate || '0', 10);
      return direction === 'asc' ? dateA - dateB : dateB - dateA;
    });

    items.forEach(item => grid.appendChild(item));
  }

  function attachSortListeners() {
    document.querySelectorAll('select[name="sort_by"]').forEach(select => {
      // Remove any previously attached listener to avoid duplicates
      select.removeEventListener('change', select._customSortHandler);

      select._customSortHandler = function (event) {
        const val = this.value;
        if (!CUSTOM_SORT_VALUES.includes(val)) return;

        // Stop Shopify's facets.js from submitting the form
        event.stopImmediatePropagation();

        const direction = val === 'event_date_asc' ? 'asc' : 'desc';
        sortByEventDate(direction);
      };

      // Use capture phase so this fires BEFORE Shopify's bubble-phase listener
      select.addEventListener('change', select._customSortHandler, true);
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', attachSortListeners);

  // Re-attach after Shopify re-renders the facets via AJAX
  document.addEventListener('shopify:section:load', attachSortListeners);

  // Also observe DOM changes in case facets are re-rendered without a section event
  const observer = new MutationObserver(() => attachSortListeners());
  document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('main-collection-filters');
    if (container) observer.observe(container, { childList: true, subtree: true });
  });
})();


